<template>
  <v-card class="mx-auto" width="100%" :href="post && post.permalink" target="_blank">
    <v-img :src="post ? (post.media_type === 'VIDEO' ? post.thumbnail_url : post.media_url) : null" height="200px"></v-img>
    <v-card-text> {{ post && post.caption ? post.caption.substring(0, 25) : '' }}... </v-card-text>

    <v-card-actions>
      <v-chip small :color="isSelected ? 'primary' : 'red'" text-color="white">
        <v-avatar left small>
          <v-icon small v-if="isSelected">mdi-checkbox-marked-circle</v-icon>
          <v-icon small v-if="!isSelected">mdi-close-circle</v-icon>
        </v-avatar>
        {{ post && post.isStory ? 'Story' : 'Post' }}
      </v-chip>

      <v-btn color="secondary" v-if="!isSelected" text @click.stop.prevent="$emit('selected')">
        Select
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn icon @click.stop.prevent="show = !show">
        <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
    </v-card-actions>

    <v-expand-transition>
      <div v-show="show">
        <v-divider></v-divider>

        <v-card-text>
          {{ post ? post.caption : '' }}
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
</template>
<script>
export default {
  props: {
    post: Object,
    isSelected: Boolean
  },
  data() {
    return {
      show: false,
      post: null
    };
  }
};
</script>



// WEBPACK FOOTER //
// Post.vue?ce613692